// hooks/useToastMutation.ts
import { useMutation } from "convex/react";
import { toast } from "sonner";
import { FunctionReference, OptionalRestArgs } from "convex/server";
import { getErrorMessage } from "@/lib/utils";

export function useToastMutation<
  Mutation extends FunctionReference<"mutation", "public", any, any>,
>(
  mutation: Mutation,
  options?: {
    loadingMessage?: string;
    successMessage?: string | ((result: Mutation["_returnType"]) => string);
    errorMessage?: string | ((error: string) => string);
  },
) {
  const mutate = useMutation(mutation);

  const execute = async (
    ...args: OptionalRestArgs<Mutation>
  ): Promise<Mutation["_returnType"]> => {
    const promise = mutate(...args) as Promise<Mutation["_returnType"]>;

    toast.promise(promise, {
      loading: options?.loadingMessage || "Procesando...",
      success: (result: Mutation["_returnType"]) => {
        const message =
          typeof options?.successMessage === "function"
            ? options.successMessage(result)
            : options?.successMessage || "¡Completado!";

        return message;
      },
      error: (error: any) => {
        const cleanError = getErrorMessage(error);

        const message =
          typeof options?.errorMessage === "function"
            ? options.errorMessage(cleanError)
            : options?.errorMessage || cleanError || "Error en la operación";

        return message;
      },
    });

    return promise;
  };

  return { execute, mutate };
}
